<script setup lang="ts">
import { type StatusType, VIcons, VStatuses } from '@/shared/ui'
import { useRouter } from 'vue-router'
import { type PropType } from 'vue'

const props = defineProps({
  item: {
    type: Object as PropType<any>,
    required: true,
  },
  type: {
    type: Object as PropType<any>,
    required: true,
  },
  statuses: {
    type: Object as PropType<StatusType[]>,
    required: true,
  },
})

const router = useRouter()

/**
 * Обработка клика перехода в мониторинг
 */
const clickMonitoringHandler = () => {
  router.push(`/objects/${props.type.alias}/${props.item.id}/monitoring`)
}
</script>

<template>
  <div class="w-object-map-info-item__header">
    <div class="w-object-map-info-item__title" :class="{ status_disabled: item.status === 0 }">
      <VIcons
        :type="type.icon"
        class="w-object-map-info-item__icon"
        :class="{
          'w-object-map-info-item__icon_danger': item.status === 3,
          'w-object-map-info-item__icon_active': item.status === 1,
          'w-object-map-info-item__icon_warning': item.status === 2,
        }"
      />

      {{ item.name }}
    </div>

    <div class="w-object-map-info-item__info">
      <VStatuses compact :statuses :class="{ status_disabled: item.status === 0 }" />

      <VIcons
        type="browse_activity"
        class="w-object-map-info-item__monitoring"
        @click.stop="clickMonitoringHandler"
      />
    </div>
  </div>
</template>
